import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import _ from "lodash";
import Schemas from "schemas";

import UserApi from "../../api/user-api";
import OECDs from "../../constants/OECDs.json";

import { Control } from "components/ui-kit/control";
import { AuthStyles, Button, PhotoDropzone } from "components/ui-kit/styled-templates";

import useFormControl from "hooks/useFormControl";
import { useStorageListener } from "hooks/useStorage";

import { EForms } from "types/enums";
import AmbassadorSettingsPanel from "../ambassadors/panels/AmbassadorSettingsPanel";

const StudentAmbassadorIntoPage = () => {
    const { t } = useTranslation();

    const uData = useStorageListener("user", {});
    const { data, onSubmit, setValues } = useFormControl({
        name: EForms.studentProfileInfo,
        schema: Schemas.studentProfileInfo
    });

    console.log('ambassador: uData = ', uData);

    useEffect(
        () =>
            setValues(
                _.pick(uData, [
                    "email",
                    "firstName",
                    "lastName",
                    "middleName",
                    "gender",
                    "departureCity",
                    "phone",
                    "socialUrl",
                    "universityName",
                    "avatar",
                    "birthday",
                    "WoS",
                    "WoS1",
                    "studentRoleType",
                    "isAmbassador"
                ])
            ),
        [uData]
    );

    return (
        <AuthStyles.Container extra={`padding-left: 304px; padding-right: 304px; margin-bottom: 30px;`}>


            <AmbassadorSettingsPanel

            />

        </AuthStyles.Container>
    );
};

export default StudentAmbassadorIntoPage;
